import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "label"]

  copy() {
    if (!navigator.clipboard) return this.flash("Не удалось")
    const text = this.sourceTarget.content.textContent.trim()
    navigator.clipboard.writeText(text).then(() => this.flash("Скопировано"),
                                             () => this.flash("Не удалось"))
  }

  flash(message) {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = message
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.labelTarget.textContent = original }, 2000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
